<a nz-dropdown [nzDropdownMenu]="menu" class="select-lang">
  {{ "LAYOUT_HEADER.DROPDOWN.LANGUAGES" | translate: currentLang }}
  <i nz-icon nzType="down"></i>
</a>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul
    nz-menu
    nzSelectable
    *ngFor="let locale of locales"
    (click)="changeLanguage(locale.code)"
  >
    <li nz-menu-item>{{ locale.label }}</li>
  </ul>
</nz-dropdown-menu>
